import { createSignalRContext } from 'react-signalr';

interface IProps<T> {
  action:
    | 'CrisisVisitStarted'
    | 'CrisisVisitFinished'
    | 'CrisisVisitCancelled'
    | 'CrisisCallReceived'
    | 'CrisisAllocationDeleted';
  callback?: (data: T) => void;
  shouldRefetchCrisisCalls?: boolean;
}

export const SignalRCrisisContext = createSignalRContext({
  shareConnectionBetweenTab: true,
});

const useCrisisSignalR = <T,>({ action, callback }: IProps<T>): void => {
  SignalRCrisisContext.useSignalREffect<string, any>(
    action,
    (data: T) => {
      callback?.(data);
    },
    [],
  );
};

export default useCrisisSignalR;
